var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daily-filter-table"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.filterDiff,"sort-by":['filter']},scopedSlots:_vm._u([{key:"item.diff",fn:function(ref){
var item = ref.item;
return [_c('span',{class:item.color+'--text'},[_vm._v(_vm._s(_vm.formatPercentage(item.diff)))])]}}])},[_vm._v(" // eslint-disable-next-line ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }